export const analisesReducer = (state = {loading: true, resultAnalisys: null, analyses: null, initialBalance: null, analisys: null } , action) => {
    switch (action.type) {
        case 'ANALISYS_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                analyses: action.payload.analyses
            }
        case 'ANALISYS_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                analisys: action.payload
            }
        case 'ANALISYS_ADD_SUCCESS':
            return {
                ...state,
                resultAnalisys: action.payload.message
            }
        case 'ANALISYS_EDIT_SUCCESS':
            return {
                ...state,
                resultAnalisys: action.payload.message
            }
        case 'ANALISYS_UPDATE_PENDING_SUCCESS':
            return {
                ...state,
                resultAnalisys: action.payload.message
            }
        case 'ANALISYS_REMOVE_RESULT':
            return {
                ...state,
                loading:false,
                resultAnalisys: action.payload.message,
                analyses: state.analyses.filter(analyses => analyses._id !== action.payload.analisys)
            }
        case 'ANALISYS_RESET_RESULT':
            return {...state,
                resultAnalisys: null
            }
        case 'ANALISYS_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'ANALISYS_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'ANALYSES_RESET':
            return {
                ...state,
                analyses: null
        }
        default:
            return state
    }
}

